module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_library.js
// module id = 1049
// module chunks = 323